import { createStyles, makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { InspectionSide_GetResponse_NetData } from '../../../../api/chatApi/chatApi'
import DetailViewBtnManipulation from './DetailViewBtnManipulation'

const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      marginTop: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        gap: theme.spacing(0.5)
      }
    },
    button: {
      minWidth: '120px',
      padding: theme.spacing(1),
      fontSize: '0.875rem',
      whiteSpace: 'nowrap',
      [theme.breakpoints.down('sm')]: {
        minWidth: '100%',
        padding: theme.spacing(0.9),
        fontSize: '0.75rem'
      }
    }
  })
)

type Props = {
  items: Array<InspectionSide_GetResponse_NetData>
  selectedId: number | null | undefined
  onSelect?: (id: number) => void
}

export default function DetailViewButtons(props: Props) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {props.items.map(it => {
        const isSelected = it.id === props.selectedId;
        return (
          <DetailViewBtnManipulation
            key={it.id}
            disabled={!isSelected}
            onClick={() => props.onSelect?.(it.id)}
          >
            {it.value}
          </DetailViewBtnManipulation>
        )
      })}
    </div>
  )
}
